import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitFinancingRedistributionBySourceLite } from "./pit-financing-redistribution-by-source-lite";
let PitFinancingRedistributionLite = class PitFinancingRedistributionLite {
};
tslib_1.__decorate([
    jsonMember({ name: 'id', constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionLite.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFinancingRedistributionBySourceLite, { name: 'financingRedistributionBySource', emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitFinancingRedistributionLite.prototype, "_financingRedistributionBySource", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionLite.prototype, "sourceActivityVersionId", void 0);
PitFinancingRedistributionLite = tslib_1.__decorate([
    jsonObject
], PitFinancingRedistributionLite);
export { PitFinancingRedistributionLite };
